import React, { useEffect,useContext } from 'react';
import moment from "moment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// core icons
import GetAppIcon from '@material-ui/icons/GetApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
//services
import { transformValueFloattoFormated,formateDateandTime, formateDate } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/contratoVenda.js";
import { Table } from '@material-ui/core';
import { SessionContext } from "beaktShared/services/session";

const useStyles = makeStyles(styles);
  
export default function ContratoVendaCamaCam(venda) {
  const classes = useStyles();
  const [logo] = React.useState(require("assets/img/LogoCamaCam.png"));
  const session = useContext(SessionContext);
  const [listTermos, setlistTermos] = React.useState([]);

  const [contratoAntigo, setcontratoAntigo] = React.useState(false);// contantes para definir quais textos serão exibidos no contrato
  const [contratoNovo, setcontratoNovo] = React.useState(false);

  
  const [dadosContrato, setdadosContrato] = React.useState({
      numeroContrato: "",
      idNetClinicas: "",
      dataEmissao: "",
      clinica_Fantasia: "",
      clinica_RazaoSocial: "",
      clinica_CNPJ: "",
      clinica_Endereco: "",
      cliente_Nome: "",
      Cliente_RG: "",
      cliente_CPF: "",
      cliente_DTNascimento: "",
      cliente_Celular: "",
      cliente_Telefone: "",
      cliente_Email: "",
      cliente_Endereco: "",
      valorTotalServicos: ""
  });
  
  const html = dadosContrato.clausulaImpressa;


  const [loading,setloading] = React.useState(false);
  const loadTermoServico = () => {
    setloading(true);
    UseGetApiSimple("termoservicos/bycontrato/" + venda.venda.numeroContrato, 0).then(result => {
      setloading(false);
      if (result.status != 200){
        return false;
      }
      setlistTermos(result.data);      
    })    
  }

  const openLink = (link) => {
    console.log(link);
    window.open(link);
  }

  useEffect(() => {    
      if (venda.venda != null)              
      {
        setdadosContrato(venda.venda);      
        loadTermoServico();
      
        // dadosContrato.novoContrato vem da api, onde verifica se o contrato foi gerado antes de 08/06/2021
        if(dadosContrato.novoContrato){
          setcontratoNovo(true);
          setcontratoAntigo(false);
        }
        else{
          setcontratoAntigo(true);
          setcontratoNovo(false);
        }
      }
  }, [venda]); 
  
return (
  
    <div style={{marginTop:'0px !important', paddingTop:'0px !important', fontWeight:'400'}}>  

        <GridContainer>      
        {loading && 
              <div className="carregandoCmp" style={{background:'white'}}>
                  <div className="box">
                      <label>Carregando...</label>
                      <CircularProgress />
                  </div>
              </div> 
          }            
          <GridItem xs={12} sm={12} md={12}>          
            <div className="no-print" style={{padding:'20px 30px'}}>
              <Button
                color="info"
                className={classes.marginRight}
                onClick={() => window.print()}
              >
                Imprimir Contrato
              </Button>
              {listTermos.map(item => (                                      
                      <Button key={item.titulo}
                        color="secondary"
                        className={classes.marginRight}                      
                        onClick={() => openLink(item.nomeArquivo)}
                      ><GetAppIcon className={classes.icons} />
                        {item.titulo}
                      </Button>                     
                ))
              }              
            </div>         
            
            <div className="allowPrint"
              style={{color:'black', maxWidth:'900px',margin:'0 auto',border:'1px solid rgb(206, 206, 206)',background:'white',padding:'20px 30px', fontWeight:'400'}}>              
              <div style={{background:'white'}} >
                <GridContainer>
              
                  <GridItem xs={12} sm={3} md={3}>
                    <img src={logo} style={{width:'200px',marginTop:'20px'}}/>
                  </GridItem>

                  <GridItem xs={12} sm={7} md={7}>
                    <div style={{fontSize:'1.0em',textAlign:'center',background:'white'}}>
                      <h5 className="badge bg-dark text-white" style={{fontSize:'1.3em',fontWeight:'bold', marginTop:'40px'}}>CONTRATO DE PRESTAÇÃO DE SERVIÇOS<br></br></h5>
                      <h5 style={{fontWeight:'bold'}}>QUALIFICAÇÃO DO CLIENTE–CONTRATANTE</h5>
                    </div>
                  </GridItem>  

                  <GridItem xs={12} sm={2} md={2}>
                    <div style={{fontSize:'1.0em',background:'white'}}>
                      <h5 style={{fontWeight:'bold',textAlign:'right'}}>{dadosContrato.clinica_Fantasia}<br></br></h5>
                      <h5 style={{fontWeight:'bold'}}>Nº {dadosContrato.idNetClinicas}</h5>
                      <h4>Data de Emissão: {formateDateandTime(dadosContrato.dataEmissao)}</h4>
                    </div>
                  </GridItem>     

                </GridContainer>
                <br></br>
                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                  <p> <b>(Contratante):</b> <span>{dadosContrato.cliente_Nome}</span></p>
                  <p> <b>Endereço:</b> <span>{dadosContrato.cliente_Endereco}</span></p>
                  <p> <b>CPF:</b> <span>{dadosContrato.cliente_CPF}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <b style={{paddingLeft:"15px"}}>RG:</b> {dadosContrato.Cliente_RG} </p>                
                  <p> <b>Fone:</b> <span>{dadosContrato.cliente_Celular != null ? dadosContrato.cliente_Celular : ''}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <b style={{paddingLeft:"15px"}}>e-mail:</b> {dadosContrato.cliente_Email} </p>                
                  <p style={{fontSize:'1.2em'}}><b>Qualificação do Prestador de serviço:</b> <b>CONTRATADA CNPJ:</b> <b>{dadosContrato.clinica_CNPJ}</b> 
                    <br></br> <b>{dadosContrato.clinica_Endereco}</b>
                  </p>                
                </div>
                <hr className="linha" style={{border:'1px solid'}}/>
                <div style={{fontSize:'1.0em',textAlign:'center'}}>
                  <h5 className="badge bg-dark text-white" style={{fontSize:'1.3em',fontWeight:'bold'}}>&nbsp;&nbsp;&nbsp;TRATAMENTOS DE ESTÉTICA CORPORAL E FACIAL&nbsp;&nbsp;&nbsp;</h5>
                </div>
                <table border="0" style={{fontSize:'1.0em',fontWeight:'bold'}}>
                  <tr>
                      <th className="text-left">1 - CRIOLIPÓLISE__________ R$ 499,00</th>
                      <th className="text-center">&nbsp;&nbsp;7 - CARBOX DERME____ R$ 173,00</th>
                      <th className="text-right">&nbsp;&nbsp;13 - MASSAGEM MODELADORA___ R$ 190,00</th>
                  </tr>
                  <tr >
                      <td className="text-left">2 - RADIOFREQUENCIA_____ R$ 210,00</td>
                      <td className="text-center">&nbsp;&nbsp;8 - ULTRASSOM_______ R$ 157,00</td>
                      <td className="text-right">&nbsp;&nbsp;4 - ORIENTAÇÃO ALIMENTAR_______ $ 220,00</td>
                  </tr>
                  <tr>
                      <td className="text-left">3 - ESTIMULAÇÃO RUSSA__ R$ 157,00</td>
                      <td className="text-center">&nbsp;&nbsp;9 - HECCUS____________ R$ 150,00</td>
                      <td className="text-right">&nbsp;&nbsp;15 - ACUPUNTURAAURICULAR_____R$ 157,00</td>
                  </tr>
                  <tr>
                      <td className="text-left">4 - CARBOX TONUS______ R$ 173,00</td>
                      <td className="text-center">&nbsp;&nbsp;10 - ESTETIC ENDERMO_ R$ 157,00</td>
                      <td className="text-right">&nbsp;&nbsp;16 - EXAME CETOSE_______________ R$ 157,00</td>
                  </tr>
                  <tr>
                      <td className="text-left">5 - LIPO CAVITAÇÃO____ R$ 220,00</td>
                      <td className="text-center">&nbsp;&nbsp;11 - DRENAGEM LINFÁTICA_R$ 150,00</td>
                      <td className="text-right">17 - MANTHUS_____________________R$ 150,00</td>
                  </tr>
                  <tr>
                      <td className="text-left">6 - INFRA RED____ R$ 157,00</td>
                      <td className="text-center">&nbsp;&nbsp;12 - LIPO DERME INJECTION_R$ 300,00 </td>
                      <td className="text-right">18 - _______________________________________</td>
                  </tr>
                </table>
                <br></br>

                <hr className="linha" style={{border:'1px solid'}}/>
                <br></br>
                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                  <p> <b>Plano opcional – tratamentos em pacotes promocionais</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>SIM</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>NÃO</b></p>
                  <p> <b>CONDIÇÕES DE EXECUÇÃO DOS SERVIÇOS DE TRATAMENTO</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>CORPORAL</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>FACIAL</b></p>
                  <p> <b>A CONTRATADA executará seus serviços profissionais referente ao tratamento especifico:</b></p>
                </div>
                
                {(dadosContrato.produtos && dadosContrato.produtos.length > 0) &&
                <div style={{fontSize:'1.0em',marginBottom:'10px'}}>
                  <h3 style={{textAlign:'center',fontWeight:'bold'}}>Produtos</h3>
                  <table className="tabelaItem6" >
                    <thead className="head-table">
                      <tr style={{ background:'#F5F5F5'}}>
                        <th>TIPO</th>
                        <th>DESCRIÇÃO</th>
                        <th>QTD</th>
                        <th className="text-right">R$ Unit.</th>
                        <th className="text-right">R$ Desc</th>
                        <th className="text-right">R$ Liquído</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosContrato.produtos && dadosContrato.produtos.map(item => ( 
                          <tr>
                              <td>{item.tipo}</td>
                              <td>{item.descricao}</td>
                              <td className="text-center">{item.qtd}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}</td>
                          </tr> 
                      ))}                         
                    </tbody>
                  </table>
                  
                  <div style={{textAlign:'right',fontSize:'1.0em'}}>
                      <h5><b>Total item: {transformValueFloattoFormated(dadosContrato.valorTotalProdutos)}</b></h5>
                  </div>
                </div>
                }
              
                {(dadosContrato.servicos && dadosContrato.servicos.length > 0) &&
                <div style={{fontSize:'1.0em',marginBottom:'10px'}}>
                  <h3 style={{textAlign:'center',fontWeight:'bold'}}>Serviços</h3>
                  <table className="tabelaItem6">
                    <thead className="head-table">
                      <tr style={{ background:'#F5F5F5'}}>
                        <th>TIPO</th>
                        <th>DESCRIÇÃO</th>
                        <th>QTD</th>
                        <th className="text-right">R$ Unit.</th>
                        <th className="text-right">R$ Desc</th>
                        <th className="text-right">R$ Liquído</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosContrato.servicos && dadosContrato.servicos.map(item => ( 
                          <tr>
                              <td>{item.tipo}</td>
                              <td>{item.descricao}</td>
                              <td className="text-center">{item.qtd}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}</td>
                          </tr> 
                      ))}                         
                    </tbody>
                  </table>
                  
                  <div style={{textAlign:'right',fontSize:'1.0em'}}>
                      <h5><b>Total item: {transformValueFloattoFormated(dadosContrato.valorTotalServicos)}</b></h5>
                  </div>
                </div>
                }

                {(dadosContrato.pacotes && dadosContrato.pacotes.length > 0) &&
                <div style={{fontSize:'1.0em',marginBottom:'10px'}}>
                  <h3 style={{textAlign:'center',fontWeight:'bold'}}>Pacotes</h3>
                  <table className="tabelaItem6">
                    <thead className="head-table">
                      <tr style={{ background:'#F5F5F5'}}>
                        <th>TIPO</th>
                        <th>DESCRIÇÃO</th>
                        <th>QTD</th>
                        <th className="text-right">R$ Unit.</th>
                        <th className="text-right">R$ Desc</th>
                        <th className="text-right">R$ Liquído</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosContrato.pacotes && dadosContrato.pacotes.map(item => ( 
                          <tr>
                              <td>{item.tipo}</td>
                              <td>
                                <b>Descrição: </b>
                                {item.descricao }
                                <br/><br/>
                                <b>Serviços: </b>
                                {JSON.stringify(item.pacoteServico).replaceAll("\"","").replaceAll("[","").replaceAll("]","")}
                                <br/><br/>
                                <b>Produtos: </b>
                                {JSON.stringify(item.pacoteProdutos).replaceAll("\"","").replaceAll("[","").replaceAll("]","")}
                              </td>
                              <td className="text-center">{item.qtd}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}</td>
                              <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}</td>
                          </tr>
                      ))}                         
                    </tbody>
                  </table>
                  
                  <div style={{textAlign:'right',fontSize:'1.0em'}}>
                      <h5><b>Total item: {transformValueFloattoFormated(dadosContrato.valorTotalPacotes)}</b></h5>
                  </div>
                </div>
                }

                <div  style={{fontSize:'1.3em',fontWeight:'bold'}} className={classes.pageBreak}>
                  <p> <b>RECEBEMOS DO(A) CLIENTE ACIMA DESCRITO, A IMPORTÂNCIA DE R$ {transformValueFloattoFormated((dadosContrato.valorTotalPacotes) + (dadosContrato.valorTotalServicos) + (dadosContrato.valorTotalProdutos))}</b></p>
                    {/* <p> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>CARTÃO</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>CHEQUE</b> <CheckBoxOutlineBlankIcon className={classes.icons} /><b>A VISTA</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>PARCELADO EM:</b></p> */}
                    {/* <p> <b>Formas de pagamento:</b> {dadosContrato.pagamentos && dadosContrato.pagamentos.map(item => (   
                        item.forma
                    ))
                          }</p> */}
                    <table className="tabelaItem6" border="1" style={{fontSize:'1.0em',fontWeight:'bold', background:'#F5F5F5'}}>
                      <thead className="head-table">
                          <tr>
                            <th>FORMA</th>
                            <th style={{textAlign:'center'}} >DETALHE</th>
                            <th style={{textAlign:'right'}}>R$ Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                            {dadosContrato.pagamentos && dadosContrato.pagamentos.map(item => ( 
                                  <tr>
                                      <td>{item.forma}</td>
                                      <td>
                                        {
                                          item.detalhe.split("<br/>").map(_detalhe => ( 
                                              <div>{_detalhe}<br/></div>
                                            ))
                                        }
                                      </td>
                                      <td style={{textAlign:'right'}}>{transformValueFloattoFormated(item.valor)}</td>
                                  </tr> 
                              ))
                            }
                        </tbody>
                    </table>
                  </div><br></br>

                <div style={{fontSize:'1.2em',fontWeight:'bold'}} className={classes.pageBreak}>
                  <hr className="linha" style={{border:'1px solid'}}/>
                  {(html != null && html != "") && <div>{ReactHtmlParser(html)}</div>}
                  {(html == null || html == "") &&
                    <div>
                      <h4><b>CONDIÇÕES GERAIS</b></h4>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        1- O presente contrato tem por objeto a prestação de serviços estéticos pela CONTRATADA para a(o) CONTRATANTE.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        2 - A(o) CONTRATANTE fica responsável pelas informações referentes a sua saúde, quanto à doenças infecto-contagiosas, alergias, gravidez, cirurgias;
                          uso de métodos contraceptivos, como o DIU, marca-passos; bem como, uso de medicamentos ingeridos habitualmente.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        3 - O descumprimento da cláusula acima descrita pela(o) CONTRATANTE, ou se, a omissão de qualquer fato relevante que possa interferir no tratamento,
                        isenta desde já a CONTRATADA de quaisquer responsabilidade do tange efeitos colaterais, seqüelas ou outra reação que porventura aconteça em
                        decorrência da pré-existência omitida.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                      4 - A(o) CONTRATANTE, obriga-se e se responsabilizar pela veracidade e exatidão das informações prestadas à CONTRATADA
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        5 - É obrigação da CONTRATADA realizar a prestação nos moldes determinados através de avaliação prévia.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        6 - A sequência da aplicação dos procedimentos indicados para a CONTRATANTE é de critério exclusivo da CONTRATADA
                      </div>  <br></br>                              
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        7 - Fica a(o) CONTRATANTE ciente de que, o consumo excessivo de fumo, álcool ou açúcar poderão afetar e/ou prejudicar o resultado do tratamento
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        8 - O pagamento dos serviços contratados poderão ser efetuados nas formas autorizadas pela CONTRATADA
                      </div> <br></br>               
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        9 - Em caso de pagamento com cheque, este recibo está sujeito a compensação dos mesmos, no caso da não compensação na data estipulada o mesmo
                          estará sujeito a protesto.
                      </div>   <br></br>             
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        10 - O intervalo dos procedimentos deverão ser respeitados conforme indicação da CONTRATADA, caso o CONTRATANTE abandone o tratamento sem
                          justificativa médica, a CONTRATADA não se responsabiliza pela devolução dos valores pagos.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        11 - Em caso de inadimplência a(o) CONTRATANTE, estará sujeito a todas as formas de cobrança previstas em Lei, extra ou judicialmente, bem como, terá
                          seu nome incluso nos órgãos de proteção ao crédito.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        12 - As sessões deverão ser previamente agendadas, sendo que quando da impossibilidade do comparecimento da (o) CONTRATANTE, a clínica deverá ser
                          comunicada com antecedência mínima de vinte e quatro horas, sob pena de ser considerada a sessão como realizada.
                      </div> <br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        13 - Os valores promocionais terão validade até o cumprimento integral do tratamento
                      </div> <br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        14 - O presente instrumento poderá ser rescindido mediante comunicação escrita com antecedência de quarenta e oito horas na sede da CONTRATADA
                      </div> <br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        15 - Em casos de rescisão e/ou cancelamento do tratamento a(o) CONTRATANTE perderá o direito aos valores promocionais, sendo que os serviços
                          executados serão cobrados, tendo por base a tabela acima descrita, acrescida de 15% (quinze por cento) sobre o valor referente ao pacote total
                          contratado.
                      </div><br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        16 - O presente contrato tem validade de até três (3) meses, a partir da data do contrato para o tratamento estético contratado acima.
                      </div> <br></br>
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        17 - Fica ciente desde já a(o) CONTRATANTE que durante o tratamento estético e/ou intradérmico poderão ocorrer hematomas no local, sendo assim,
                          pede-se para que a área tratada não seja exposta ao sol, durante este período.
                      </div> 
                      <div className={classes.pageBreak} style={{textAlign:'justify'}}> 
                        18 - Por estarem assim, justos e contratados, dão sua ciência e firmam o presente instrumento, em duas vias de igual teor
                      </div> <br></br>
                    </div>
                  }
                  <hr className="linha" style={{border:'1px solid'}}/><br></br>
                  <div className={classes.pageBreak} style={{fontSize:'1.2em',textAlign:'justify'}}> 
                    Declaro que estou ciente de todas as cláusulas acima descritas e que compreendi, não me restando quaisquer dúvidas
                        que a prática médica/estética não é uma ciência exata, apresentando resultados progressivos, dependendo da reação
                        do organismo de cada cliente e que diante disso, não se podem dar garantias, nem certezas quanto aos resultados dos
                        tratamentos propostos.
                  </div> 
                </div>              
              </div>              
                  <div className={classes.pageBreak} style={{fontSize:'1.2em',marginBottom:'5px !important',paddingBottom:'0px !important',fontWeight:'bold'}}>                       
                    <br/>
                    <br/>                                               
                    <GridContainer>
              
                      <GridItem xs={12} sm={6} md={6}>
                        <p style={{textAlign:'center',fontWeight:'400',fontWeight:'bold'}}> 
                        ______________________________________<br/>
                        CONTRATADA
                        </p>
                      </GridItem>  

                      <GridItem xs={12} sm={6} md={6}>
                        <p style={{textAlign:'center',fontWeight:'400',fontWeight:'bold'}}> 
                        ______________________________________<br/>
                        CONTRATANTE
                        </p>
                      </GridItem>     

                    </GridContainer>
                  </div>                  
            </div>                
 
          </GridItem>
        
        </GridContainer>        
        
    </div>
);
}